import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { ALL_WEEKS } from "./weeklyModel";

const DAY = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
const DAY_YEAR = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });

/** "Oct 5 – 11, 2026" style span of the week starting on `iso`. */
export const weekSpan = (iso) => {
  const start = new Date(`${iso}T00:00:00Z`);
  const end = new Date(start);
  end.setUTCDate(end.getUTCDate() + 6);
  return `${DAY.format(start)} – ${DAY_YEAR.format(end)}`;
};

const capitalize = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);

// Which week the table (and so the download) shows.
export const WeekPicker = ({ weeks, week, onChange, weekStart }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap", mb: 1.5 }}>
    <TextField
      select
      size="small"
      label="Week"
      value={week}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth: 240 }}
    >
      <MenuItem value={ALL_WEEKS}>All weeks ({weeks.length})</MenuItem>
      {[...weeks].reverse().map((w) => (
        <MenuItem key={w} value={w}>
          {weekSpan(w)}
        </MenuItem>
      ))}
    </TextField>
    <Typography variant="body2" color="text.secondary">
      {week === ALL_WEEKS ? "Showing and downloading every week" : "Showing and downloading this week only"}
      {weekStart ? ` · Weeks start on ${capitalize(weekStart)}` : ""}
    </Typography>
  </Box>
);
